import { gql } from '@apollo/client'

export const GET_MY_PERMISSIONS = gql`
  query MyPermissions {
    myPermissions {
      id
      name
      description
    }
  }
`
